<template>
  <span class="sera-badge" :class="{ [`sera-badge--${props.color}`]: true }">
    <Tooltip v-if="tooltipText" width="300" placement="top">
      <template #trigger>
        <div class="d-flex align-items-center">
          <span class="sera-badge__text">{{ props.text }}</span>
          <i
            v-if="props.icon"
            class="sera-badge__icon fa-regular"
            :class="{ [props.icon]: true }"
          />
        </div>
      </template>
      <template #tooltip>
        <div class="text-center">
          {{ tooltipText }}
        </div>
      </template>
    </Tooltip>
    <span v-else>
      <span class="sera-badge__text">{{ props.text }}</span>
      <i
        v-if="props.icon"
        class="sera-badge__icon fa-regular"
        :class="{ [props.icon]: true }"
      />
    </span>
  </span>
</template>

<script setup lang="ts">
import Tooltip from "./Tooltip.vue";

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: false
  },
  color: {
    type: String,
    default: null
  },
  tooltipText: {
    type: String,
    required: false,
    default: null
  }
});
</script>

<style lang="scss" scoped>
.sera-badge {
  display: flex;
  align-items: center;
  height: 26px;
  padding: 0px 8px;
  font-size: 14px;
  font-weight: normal;
  border-radius: 4px;
  margin-left: 16px;
  background: #f4f5f5;
  border: 1px solid #9ca4aa;

  &--gray {
    background: #f4f5f5;
    border-color: #9ca4aa;
  }
  &--red {
    background: #ffecec;
    border-color: #de0000;
  }
  &--green {
    background: #f0fff1;
    border-color: #008a09;
  }
  &--yellow {
    background: #fff9df;
    border-color: #ffda33;
  }
  &--blue {
    background: #e9f4ff;
    border-color: #125aeb;
  }

  &__text {
  }

  &__icon {
    margin-left: 8px;
  }
}
</style>